import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface UserState {
  isUserAuthenticated: boolean;
  userId: string;
  role: string;
  platformPermissions: any[];
  authHydrated: boolean;
}

const initialState: UserState = {
  isUserAuthenticated: false,
  userId: "",
  role: "",
  platformPermissions: [],
  authHydrated: false,
};

const getInitialState = (): UserState => {
  const token = localStorage.getItem("sm-access-token") ?? "";

  return {
    ...initialState,
    authHydrated: !token,
  };
};

export const userSlice = createSlice({
  name: "user",
  initialState: getInitialState,
  reducers: {
    setUserAuth: (
      state,
      action: PayloadAction<{
        authenticated: boolean;
        role: string;
        userId: string;
      }>
    ) => {
      state.role = action.payload.role;
      state.isUserAuthenticated = action.payload.authenticated;
      state.userId = action.payload.userId;
    },

    setAuthHydrated: (state, action: PayloadAction<boolean>) => {
      state.authHydrated = action.payload;
    },

    setPlatformPermissions: (state, action: PayloadAction<any>) => {
      state.platformPermissions = action.payload;
    },
    reset: () => getInitialState(),
  },
});

export const { setUserAuth, setAuthHydrated, reset, setPlatformPermissions } =
  userSlice.actions;

export default userSlice.reducer;
